import React from 'react'
import { StyledLink } from '../../components/StyledComponents'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'

const OtherWhitepapers = (props) => {
    const language = useSelector(selectLanguage)

    return (
        <div className='container pt-50'>
            {language === "en"
                ?
                <p className='text-center font-48 text-white font-weight-semi-bold'>Other Whitepapers by Qrypto</p>
                :
                <p className='text-center font-48 text-white font-weight-semi-bold'>Các whitepapers khác của Qrypto</p>
            }
            <div className='row'>
                {props.items.map((item, index) => (
                    <div className='col-xl-4 col-md-6' key={item.id}>

                        <div className="whitepapers-card">
                            <StyledLink href={item.link}>
                                <div className='whitepapers-card_image'>
                                    <img src={item.image} alt="" className='img-responsive' />
                                </div>
                            </StyledLink>
                            <div className='case-study-chip mt-20'>
                                {item.chip}
                            </div>
                            <StyledLink href={item.link}>
                                <p className='pt-20 text-white font-20 font-weight-semi-bold'>{item.title}</p>
                            </StyledLink>
                            <p className='text-gray pt-20'>{item.content}</p>
                        </div>

                    </div>
                ))}
            </div>
        </div>
    )
}

export default OtherWhitepapers